import React from 'react';
import { FaBatteryFull, FaSignal, FaWifi } from 'react-icons/fa';

const MessagePreview = ({
  content,
  image,
  messageId,
  messageType,
  optOutWord,
}) => {
  const currentTime = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  const formattedContent = content.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {content && <br />}

      {/* {index < content.split('\n').length - 1 && <br />} */}
    </React.Fragment>
  ));

  return (
    <div className='w-full max-w-[330px] min-w-[260px] h-[500px] bg-gray-800 rounded-3xl overflow-hidden shadow-lg relative mx-auto'>
      <div className=' text-white py-2 px-4 flex justify-between items-center'>
        <span>{currentTime}</span>
        <div className='flex items-center space-x-2'>
          <FaSignal />
          <FaWifi />
          <FaBatteryFull />
        </div>
      </div>
      <div className='h-[520px] bg-gray-200 p-4 overflow-y-auto'>
        <div className='bg-green-500 text-white p-3 rounded-lg mb-2 max-w-[80%] ml-auto'>
          {formattedContent}
          {messageType === 'coupon' && (
            <>
              {/* <br /> */}
              Coupon: localhost:3000/redeem/(unique coupon code)
              <br />
            </>
          )}
          {optOutWord && <>Reply "OPT OUT {optOutWord}" to unsubscribe.</>}
        </div>
        {image && (
          <div className='bg-green-500 p-1 rounded-lg mb-2 max-w-[80%] ml-auto'>
            {/* <img src={image} alt='Attached' className='w-full h-auto rounded' /> */}
            <img
              src={image instanceof File ? URL.createObjectURL(image) : image}
              alt='Attached'
              className='w-full h-auto rounded'
            />
          </div>
        )}
      </div>
      <div className='absolute bottom-0 left-0 right-0 h-16 bg-gray-800 flex justify-center items-center'>
        <div className='w-32 h-1 bg-white rounded-full'></div>
      </div>
    </div>
  );
};

export default MessagePreview;

// import React from 'react';
// import { FaBatteryFull, FaSignal, FaWifi } from 'react-icons/fa';

// const MessagePreview = ({ content }) => {
//   const currentTime = new Date().toLocaleTimeString([], {
//     hour: '2-digit',
//     minute: '2-digit',
//   });

//   const formattedContent = content.split('\n').map((line, index) => (
//     <React.Fragment key={index}>
//       {line}
//       <br />
//     </React.Fragment>
//   ));

//   return (
//     <div className='w-full max-w-[320px] h-[600px] bg-gray-800 rounded-3xl overflow-hidden shadow-lg relative mx-auto'>
//       <div className='bg-black text-white p-2 flex justify-between items-center'>
//         <span>{currentTime}</span>
//         <div className='flex items-center space-x-2'>
//           <FaSignal />
//           <FaWifi />
//           <FaBatteryFull />
//         </div>
//       </div>
//       <div className='h-[520px] bg-gray-200 p-4 overflow-y-auto'>
//         <div className='bg-green-500 text-white p-3 rounded-lg mb-2 max-w-[80%] ml-auto'>
//           {formattedContent}
//         </div>
//       </div>
//       <div className='absolute bottom-0 left-0 right-0 h-16 bg-gray-800 flex justify-center items-center'>
//         <div className='w-32 h-1 bg-white rounded-full'></div>
//       </div>
//     </div>
//   );
// };

// export default MessagePreview;
// import React from 'react';
// import { FaBatteryFull, FaSignal, FaWifi } from 'react-icons/fa';

// const MessagePreview = ({
//   content,
//   image,
//   messageId,
//   messageType,
//   optOutWord,
// }) => {
//   const currentTime = new Date().toLocaleTimeString([], {
//     hour: '2-digit',
//     minute: '2-digit',
//   });

//   const formattedContent = content.split('\n').map((line, index) => (
//     <React.Fragment key={index}>
//       {line}
//       {index < content.split('\n').length - 1 && <br />}
//     </React.Fragment>
//   ));

//   const imageUrl = image instanceof File ? URL.createObjectURL(image) : image;

//   return (
//     <div className='w-full max-w-[320px] h-[600px] bg-gray-800 rounded-3xl overflow-hidden shadow-lg relative mx-auto'>
//       <div className='bg-black text-white p-2 flex justify-between items-center'>
//         <span>{currentTime}</span>
//         <div className='flex items-center space-x-2'>
//           <FaSignal />
//           <FaWifi />
//           <FaBatteryFull />
//         </div>
//       </div>
//       <div className='h-[520px] bg-gray-200 p-4 overflow-y-auto'>
//         <div className='bg-green-500 text-white p-3 rounded-lg mb-2 max-w-[80%] ml-auto'>
//           {formattedContent}
//           {messageType === 'coupon' && (
//             <>
//               <br />
//               <br />
//               Coupon: localhost:3000/redeem/(unique coupon code)
//               <br />
//               <br />
//             </>
//           )}
//           {optOutWord && (
//             <>
//               <br />
//               <br />
//               Reply "OPT OUT {optOutWord}" to unsubscribe.
//             </>
//           )}
//         </div>
//         {imageUrl && (
//           <div className='bg-green-500 p-1 rounded-lg mb-2 max-w-[80%] ml-auto'>
//             <img
//               src={imageUrl}
//               alt='Attached'
//               className='w-full h-auto rounded'
//             />
//           </div>
//         )}
//       </div>
//       <div className='absolute bottom-0 left-0 right-0 h-16 bg-gray-800 flex justify-center items-center'>
//         <div className='w-32 h-1 bg-white rounded-full'></div>
//       </div>
//     </div>
//   );
// };

// export default MessagePreview;
// import React from 'react';
// import { FaBatteryFull, FaSignal, FaWifi } from 'react-icons/fa';

// const MessagePreview = ({
//   content,
//   image,
//   messageId,
//   messageType,
//   optOutWord,
// }) => {
//   const currentTime = new Date().toLocaleTimeString([], {
//     hour: '2-digit',
//     minute: '2-digit',
//   });

//   const formattedContent = content.split('\n').map((line, index) => (
//     <React.Fragment key={index}>
//       {line}
//       {content && <br />}
//     </React.Fragment>
//   ));

//   const imageUrl = image instanceof File ? URL.createObjectURL(image) : image;

//   return (
//     <div className='w-full max-w-[320px] h-[600px] bg-gray-800 rounded-3xl overflow-hidden shadow-lg relative mx-auto'>
//       <div className='bg-black text-white p-2 flex justify-between items-center'>
//         <span>{currentTime}</span>
//         <div className='flex items-center space-x-2'>
//           <FaSignal />
//           <FaWifi />
//           <FaBatteryFull />
//         </div>
//       </div>
//       <div className='h-[520px] bg-gray-200 p-4 overflow-y-auto'>
//         <div className='bg-green-500 text-white p-3 rounded-lg mb-2 max-w-[80%] ml-auto'>
//           {formattedContent}
//           {messageType == 'coupon' && (
//             <>
//               {/* <br /> */}
//               {/* <br /> */}
//               Coupon: localhost:3000/redeem/(unique coupon code)
//               <br />
//               <br />
//             </>
//           )}
//           {optOutWord && (
//             <>
//               {/* <br /> */}
//               {/* <br /> */}
//               Reply "OPT OUT {optOutWord}" to unsubscribe.
//             </>
//           )}
//         </div>
//         {/* {image && (
//           <div className='bg-green-500 p-1 rounded-lg mb-2 max-w-[80%] ml-auto'>
//             <img
//               // src={URL.createObjectURL(image)}
//               src={messageId ? image : URL.createObjectURL(image)}
//               alt='Attached'
//               className='w-full h-auto rounded'
//             />
//           </div>
//         )} */}
//         {imageUrl && (
//           <div className='bg-green-500 p-1 rounded-lg mb-2 max-w-[80%] ml-auto'>
//             <img
//               // src={URL.createObjectURL(image)}
//               // src={imageUrl}
//               src={messageId ? image : URL.createObjectURL(image)}
//               alt='Attached'
//               className='w-full h-auto rounded'
//             />
//           </div>

//           // <img src={imageUrl} alt="Message preview" className="max-w-full h-auto" />
//         )}
//       </div>
//       <div className='absolute bottom-0 left-0 right-0 h-16 bg-gray-800 flex justify-center items-center'>
//         <div className='w-32 h-1 bg-white rounded-full'></div>
//       </div>
//     </div>
//   );
// };

// export default MessagePreview;

// import React from 'react';
// import { FaBatteryFull, FaSignal, FaWifi } from 'react-icons/fa';

// const MessagePreview = ({ content, couponDescription, optOutWord }) => {
//   const currentTime = new Date().toLocaleTimeString([], {
//     hour: '2-digit',
//     minute: '2-digit',
//   });

//   const formattedContent = content.split('\n').map((line, index) => (
//     <React.Fragment key={index}>
//       {line}
//       <br />
//     </React.Fragment>
//   ));

//   return (
//     <div className='w-full max-w-[320px] h-[600px] bg-gray-800 rounded-3xl overflow-hidden shadow-lg relative mx-auto'>
//       {/* <div className='absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-6 bg-black rounded-b-2xl'></div> */}
//       <div className='bg-black text-white p-2 flex justify-between items-center'>
//         <span>{currentTime}</span>
//         <div className='flex items-center space-x-2'>
//           <FaSignal />
//           <FaWifi />
//           <FaBatteryFull />
//         </div>
//       </div>
//       <div className='h-[520px] bg-gray-200 p-4 overflow-y-auto'>
//         <div className='bg-green-500 text-white p-3 rounded-lg mb-2 max-w-[80%] ml-auto'>
//           {formattedContent}
//           {couponDescription && (
//             <>
//               {/* <br /> */}
//               <br />
//               {couponDescription}
//             </>
//           )}
//           {optOutWord && (
//             <>
//               <br />
//               <br />
//               Reply "OPT OUT {optOutWord}" to unsubscribe.
//             </>
//           )}
//         </div>
//       </div>
//       <div className='absolute bottom-0 left-0 right-0 h-16 bg-gray-800 flex justify-center items-center'>
//         <div className='w-32 h-1 bg-white rounded-full'></div>
//       </div>
//     </div>
//   );
// };

// export default MessagePreview;
// import React from 'react';
// import { FaBatteryFull, FaSignal, FaWifi } from 'react-icons/fa';

// const MessagePreview = ({ content, couponDescription, optOutWord }) => {
//   const currentTime = new Date().toLocaleTimeString([], {
//     hour: '2-digit',
//     minute: '2-digit',
//   });

//   return (
//     <div className='w-80 h-[600px] bg-gray-800 rounded-3xl overflow-hidden shadow-lg relative mx-auto'>
//       <div className='absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-6 bg-black rounded-b-2xl'></div>
//       <div className='bg-black text-white p-2 flex justify-between items-center'>
//         <span>{currentTime}</span>
//         <div className='flex items-center space-x-2'>
//           <FaSignal />
//           <FaWifi />
//           <FaBatteryFull />
//         </div>
//       </div>
//       <div className='h-[520px] bg-gray-200 p-4 overflow-y-auto'>
//         <div className='bg-green-500 text-white p-3 rounded-lg mb-2 max-w-[80%] ml-auto'>
//           {content}
//           {couponDescription && (
//             <>
//               <br />
//               <br />
//               {couponDescription}
//             </>
//           )}
//           {optOutWord && (
//             <>
//               <br />
//               <br />
//               Reply "OPT OUT {optOutWord}" to unsubscribe.
//             </>
//           )}
//         </div>
//       </div>
//       <div className='absolute bottom-0 left-0 right-0 h-16 bg-gray-800 flex justify-center items-center'>
//         <div className='w-32 h-1 bg-white rounded-full'></div>
//       </div>
//     </div>
//   );
// };

// export default MessagePreview;

// import React from 'react';
// import { FaMobile } from 'react-icons/fa';

// const MessagePreview = ({ content }) => {
//   return (
//     <div className='flex flex-col items-center mt-4'>
//       <div className='w-64 h-96 bg-gray-200 rounded-3xl overflow-hidden shadow-lg relative'>
//         <div className='absolute top-0 left-0 right-0 h-6 bg-black rounded-t-3xl'></div>
//         <div className='absolute bottom-0 left-0 right-0 h-12 bg-black rounded-b-3xl flex justify-center items-center'>
//           <div className='w-24 h-6 bg-gray-400 rounded-full'></div>
//         </div>
//         <div className='h-full pt-8 pb-14 px-4 overflow-y-auto'>
//           <div className='bg-blue-500 text-white p-3 rounded-lg mb-2 max-w-[80%]'>
//             {content || 'Your message preview will appear here'}
//           </div>
//         </div>
//       </div>
//       <div className='mt-2 text-gray-600'>
//         <FaMobile className='inline mr-1' />
//         Message Preview
//       </div>
//     </div>
//   );
// };

// export default MessagePreview;
